import React from 'react';
import PropTypes from 'prop-types';
import ASQSimpleSurveyHeaderSort from './ASQSimpleSurveyHeaderSort';

export default class ASQSimpleSurveysHeader extends React.Component {
    static propTypes = {
      meta: PropTypes.object.isRequired,
      onSortChange: PropTypes.func.isRequired,
    }

    onSortChange = (e) => {
      const sort = e.currentTarget.dataset.sort;
      const order = this.props.meta.order || 'asc';
      const newOrder = order === 'desc' ? 'asc' : 'desc';
      this.props.onSortChange(sort, newOrder);
    }

    render() {
      const { meta } = this.props;
      return (
        <div className='o-rtable__row'>
          <ASQSimpleSurveyHeaderSort meta={meta} idx={1} onSortChange={this.onSortChange}>
            <b>ASQ</b>
          </ASQSimpleSurveyHeaderSort>
          <ASQSimpleSurveyHeaderSort meta={meta} idx={2} cls='o-rtable__cell--date' onSortChange={this.onSortChange}>
            <b>Date Completed</b>
          </ASQSimpleSurveyHeaderSort>
          <ASQSimpleSurveyHeaderSort meta={meta} idx={3} onSortChange={this.onSortChange}>
            <b>ASQ Score</b>
          </ASQSimpleSurveyHeaderSort>
        </div>
      );
    }
}
